/* ========== Infinite Options Customization - Product Page ========== */
// Invoked from 'product-template' section file

// Recent update - disable 'UPGRADE YOUR LENSES' > prescription radio + prescription fields (presc_pd + presc_table), commented out below ▼.
// Updated css as well
	let isTable = false;
    const handleInfinite1 = (e) => {
    	if ($('.infinite-2-btn').hasClass('is-open') && !e.currentTarget.classList.contains('is-open')) {
        	$('.infinite-2-btn').removeClass('is-open');
          	$('.infinite-2-content').removeClass('is-open');
          	$('.infinite-2-content').css('height', '0');
          	if ($('.infinite-2-btn').find('#infiniteoptions-container').length) {
    			$('.infinite-2-content .collapsible-content__inner #infiniteoptions-container').detach().appendTo('.infinite-1-content .collapsible-content__inner');
              	$('#infiniteoptions-container').show();
              	$('#infiniteoptions-container .inscription').hide();
        		$('#infiniteoptions-container [aria-labelledby="coat_choose-1-1"]').hide();
        		$('#infiniteoptions-container .color_code_left').hide();
        		$('#infiniteoptions-container .color_code_right').hide();
        		$('#infiniteoptions-container .comments').hide();
              	$('#infiniteoptions-container .lenses_type').show();
//         		$('#infiniteoptions-container .presc_pd').show();
//               	isTable && $('.presc_table').show();
              	return;
			}
          	$('#infiniteoptions-container').appendTo('.infinite-1-content .collapsible-content__inner');
          	$('#infiniteoptions-container').show();
            $('#infiniteoptions-container .inscription').hide();
        	$('#infiniteoptions-container [aria-labelledby="coat_choose-1-1"]').hide();
        	$('#infiniteoptions-container .color_code_left').hide();
        	$('#infiniteoptions-container .color_code_right').hide();
        	$('#infiniteoptions-container .comments').hide();
        	$('#infiniteoptions-container .lenses_type').show();
//         	$('#infiniteoptions-container .presc_pd').show();
//           	isTable && $('.presc_table').show();
            return;
        }
        if ($('.infinite-2-btn').find('#infiniteoptions-container').length) {
    		$('.infinite-2-content .collapsible-content__inner #infiniteoptions-container').detach().appendTo('.infinite-1-content .collapsible-content__inner');
          	$('#infiniteoptions-container').show();
          	$('#infiniteoptions-container .inscription').hide();
          	$('#infiniteoptions-container [aria-labelledby="coat_choose-1-1"]').hide();
          	$('#infiniteoptions-container .color_code_left').hide();
          	$('#infiniteoptions-container .color_code_right').hide();
          	$('#infiniteoptions-container .comments').hide();
          
          	$('#infiniteoptions-container .lenses_type').show();
// 			$('#infiniteoptions-container .presc_pd').show();      
//           	isTable && $('.presc_table').show();
        	return;
		}
        $('#infiniteoptions-container').appendTo('.infinite-1-content .collapsible-content__inner');
        $('#infiniteoptions-container').show();
        $('#infiniteoptions-container .inscription').hide();
        $('#infiniteoptions-container [aria-labelledby="coat_choose-1-1"]').hide();
        $('#infiniteoptions-container .color_code_left').hide();
        $('#infiniteoptions-container .color_code_right').hide();
        $('#infiniteoptions-container .comments').hide();
        
        $('#infiniteoptions-container .lenses_type').show();
// 		$('#infiniteoptions-container .presc_pd').show();
//         isTable && $('.presc_table').show();
	}
    const handleInfinite2 = (e) => {
    	if ($('.infinite-1-btn').hasClass('is-open') && !e.currentTarget.classList.contains('is-open')) {
        	$('.infinite-1-btn').removeClass('is-open');
          	$('.infinite-1-content').removeClass('is-open');
          	$('.infinite-1-content').css('height', '0');
          	if ($('.infinite-1-btn').find('#infiniteoptions-container').length) {
    			$('.infinite-1-content .collapsible-content__inner #infiniteoptions-container').detach().appendTo('.infinite-2-content .collapsible-content__inner');
              	$('#infiniteoptions-container').show();
              	$('#infiniteoptions-container .inscription').show();
        		$('#infiniteoptions-container [aria-labelledby="coat_choose-1-1"]').show();
        		$('#infiniteoptions-container .color_code_left').show();
        		$('#infiniteoptions-container .color_code_right').show();
        		$('#infiniteoptions-container .comments').show();
		        $('#infiniteoptions-container .lenses_type').hide();
				$('#infiniteoptions-container .presc_pd').hide();
              	$('#infiniteoptions-container .presc_table').hide();
              $('.infinite-2-content.s-open > .collapsible-content__inner').hide();
              	return;
			}
          	$('#infiniteoptions-container').appendTo('.infinite-2-content .collapsible-content__inner');
          	$('#infiniteoptions-container').show();
          	$('#infiniteoptions-container .inscription').show();
      		$('#infiniteoptions-container [aria-labelledby="coat_choose-1-1"]').show();
      		$('#infiniteoptions-container .color_code_left').show();
      		$('#infiniteoptions-container .color_code_right').show();
      		$('#infiniteoptions-container .comments').show();
		    $('#infiniteoptions-container .lenses_type').hide();
			$('#infiniteoptions-container .presc_pd').hide();
           	$('#infiniteoptions-container .presc_table').hide();
          $('.infinite-2-content.s-open > .collapsible-content__inner').hide();
        }
        if ($('.infinite-1-btn').find('#infiniteoptions-container').length) {
    		$('.infinite-1-content .collapsible-content__inner #infiniteoptions-container').detach().appendTo('.infinite-2-content .collapsible-content__inner');
          	$('#infiniteoptions-container').show();
          	$('#infiniteoptions-container .inscription').show();
        	$('#infiniteoptions-container [aria-labelledby="coat_choose-1-1"]').show();
        	$('#infiniteoptions-container .color_code_left').show();
        	$('#infiniteoptions-container .color_code_right').show();
        	$('#infiniteoptions-container .comments').show();
		    $('#infiniteoptions-container .lenses_type').hide();
			$('#infiniteoptions-container .presc_pd').hide();
          	$('#infiniteoptions-container .presc_table').hide();
          $('.infinite-2-content.s-open > .collapsible-content__inner').hide();
        	return;
		}
        $('#infiniteoptions-container').appendTo('.infinite-2-content .collapsible-content__inner');
        $('#infiniteoptions-container').show();
        $('#infiniteoptions-container .inscription').show();
        $('#infiniteoptions-container [aria-labelledby="coat_choose-1-1"]').show();
        $('#infiniteoptions-container .color_code_left').show();
        $('#infiniteoptions-container .color_code_right').show();
        $('#infiniteoptions-container .comments').show();
		$('#infiniteoptions-container .lenses_type').hide();
		$('#infiniteoptions-container .presc_pd').hide();
        $('#infiniteoptions-container .presc_table').hide();
        $('.infinite-2-content.s-open > .collapsible-content__inner').hide();
        
	}
      
	const createTable = () => {
      	isTable = true;
		const right_sph = document.querySelector('.right_sph');
		const right_cyl = document.querySelector('.right_cyl');
		const right_axe = document.querySelector('.right_axe');
		const right_add = document.querySelector('.right_add');
		const rightArr = [right_sph, right_cyl, right_axe, right_add];
		        
		const left_sph = document.querySelector('.left_sph');
		const left_cyl = document.querySelector('.left_cyl');
		const left_axe = document.querySelector('.left_axe');
		const left_add = document.querySelector('.left_add');
		const leftArr = [left_sph, left_cyl, left_axe, left_add];
		      
		const presc_table = document.createElement('table');
		presc_table.innerHTML = "<thead><tr><td></td><td>SPH</td><td>CYL</td><td>AXE</td><td>Add</td></tr></thead><tbody><tr class='right_tr'><td><strong>Right Eye</strong></td></tr><tr class='left_tr'><td><strong>Left Eye</strong></td></tr>"
          	presc_table.className = 'presc_table';
		$('#infiniteoptions-container .presc_pd').after(presc_table);
    	
		const right_tr = document.querySelector('.right_tr');
		const left_tr = document.querySelector('.left_tr');
		rightArr.forEach((item) => {
			const td = document.createElement('td');
			td.appendChild(item);
			right_tr.appendChild(td);
		});
		leftArr.forEach((item) => {
			const td = document.createElement('td');
			td.appendChild(item);
			left_tr.appendChild(td);
	  	});
    }


	/* Add custom product (Sun lenses/Polarized sun glasses) when checked */
	document.addEventListener('ajaxProduct:added', function(evt) {
  		const product = evt.detail.product;
      	if(product.properties['Lenses type'].toLowerCase().includes('polarized sun lenses') && product.properties['Lenses type'].includes('$57')) {
        	$.post('/cart/add.js', { items: [{ id: 40619087593665, quantity: 1 }] }, () => document.dispatchEvent(new CustomEvent('cart:build')), 'json')
              .catch(err => console.log(err));
        } else if(product.properties['Lenses type'].toLowerCase().includes('polarized sun lenses') && product.properties['Lenses type'].includes('$34')) {
        	$.post('/cart/add.js', { items: [{ id: 40619087560897, quantity: 1 }] }, () => document.dispatchEvent(new CustomEvent('cart:build')), 'json')
              .catch(err => console.log(err));
        } else if(product.properties['Lenses type'].toLowerCase().includes('sun lenses')) {
        	$.post('/cart/add.js', { items: [{ id: 40058854113473, quantity: 1 }] }, () => document.dispatchEvent(new CustomEvent('cart:build')), 'json')
              .catch(err => console.log(err));
        }
	});
/*===============================================================================================*/

/* =======POPUP========== */

  $(()=>{  

    if(sessionStorage.getItem('popupVisible') !== "true"){
       getCountry();
      }	
      checkCountry()
  });

  const getCountry = async () => {
    const url ="http://api.ipapi.com/api/check?access_key=ffb5be7d331a5242fd4130acc8370b33";
    let res = await fetch(url);
    let data = await res.json();  

    if(data.country_code == "AU" ||  data.country_code == "ZA"){        
      $(".new-modal").fadeIn().css("display","flex");  
      $(".payment-buttons").hide(); 
      $(".product__quantity").hide();
      sessionStorage.setItem("popupVisible",true);
      $(".country").append(data.country_name)
    }
    
     //Australian version      
    if(data.country_code == "AU"){
      $(".text").html(`
        Good news is that you can still shop our hand painted frames!<br> 
        In the store locator, you'll find retailers near you,<br> please use the filters to choose Ronit Furst.<br>
        If you couldn't find
        a nearby store, contact us!<br> we'll do our best to help.
    `)
      
      $(".btn1").click(()=>{ 
       window.location.assign("https://www.seemeeyewear.com.au/pages/store-locator")            
      })    
    }
  };

  const checkCountry=()=>{
     if(sessionStorage.getItem("popupVisible") == "true"){
      $(".payment-buttons").hide(); 
      $(".product__quantity").hide();
     }
  };

  /* =======BUTTONS========== */

  $(".close").click(()=>{ $(".new-modal").fadeOut()});

  $(".btn1").click(()=>{ 
      window.location.assign("/pages/store-locator")         
  });

  $(".btn2").click(()=>{ $(".new-modal").fadeOut()});

  $(".btn3").click(()=>{ 
      window.location.assign("/pages/contact-us")            
  });